import { Title, Stack } from "@mantine/core";
import {
  ContactoConClientes,
  Jefe,
  ParticipacionEnComite,
  TiempoTrabajando,
} from ".";
import { TStaffSurveyStatus } from "../../../types/TStaffSurveyStatus";

type Props = {
  form: any;
  setParteDeRecursosHumanos: (value: boolean) => void;
  staff_survey: TStaffSurveyStatus;
};

export const InformacionLaboralFija = ({
  form,
  setParteDeRecursosHumanos,
  staff_survey,
}: Props) => {
  return (
    <Stack spacing="lg">
      <Title order={3}>Información Laboral</Title>
      {staff_survey.flag_006 && <TiempoTrabajando form={form} />}
      <ContactoConClientes form={form} />
      <ParticipacionEnComite
        form={form}
        setParteDeRecursosHumanos={setParteDeRecursosHumanos}
      />
      <Jefe form={form} />
    </Stack>
  );
};
